import gql from 'graphql-tag';


const mutationName = 'logoutUser';

export const LOGOUT_USER = {
  mutationName,
  mutationBody: gql`
    mutation ${mutationName}(
      $input: LogoutUserMutationInput!
    ) {
      ${mutationName}(
        input: $input)
       {
        clientMutationId
      }
    }
  `,
};
